// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#learner-table-pagination[data-v-4d6c72bc]{padding-top:0;padding-bottom:0;height:35px;display:flex;flex-flow:row;justify-content:center;align-items:center}#pagination button[data-v-4d6c72bc],#pagination ul[data-v-4d6c72bc]{background-color:#fafafa!important}", ""]);
// Exports
module.exports = exports;
